import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import './index.css';
import { AppProviders } from './app/providers';
import { router } from './app/router';
import { ErrorBoundary, FullPageLoader } from '@/shared/ui';
import { RootErrorFallback } from './app/RootErrorFallback';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');
const root = ReactDOM.createRoot(rootEl);
root.render(
  <AppProviders>
    <ErrorBoundary fallback={() => <RootErrorFallback />}>
      <Suspense fallback={<FullPageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </ErrorBoundary>
  </AppProviders>
);
